module.exports = __webpack_public_path__ + "static/portfolio_gallery_2-08149f27d8bf14fa2b3395b37cf134c6.jpg";